import ProfileHOC from './ProfileHOC';
import ProfileHOCWithLists from './ProfileHOCWithLists';
import { HOCList } from './HOCList';
import * as HeaderComponents from '../../elements/header';
import * as BodyComponents from '../../elements/body';
import * as Forms from '../../elements/forms/GenerateForms';
import {
	EndorsementsManager,
	DisplayEndorsements,
} from '../../elements/body/endorsements';
import {
	PressItem,
	AwardItem,
	PublicationItem,
} from '../../elements/body/achievements';

const Headline = ProfileHOC(HeaderComponents.Headline, Forms.headline);
const Location = ProfileHOC(HeaderComponents.Location, Forms.location);
const Industry = ProfileHOC(HeaderComponents.Industry, Forms.industry);
const Endorsements = ProfileHOC(
	BodyComponents.Endorsements,
	Forms.requestEndorsement,
	true
);
const ManageEndorsements = ProfileHOC(DisplayEndorsements, EndorsementsManager);
const Press = ProfileHOC(PressItem, Forms.press);
const Awards = ProfileHOC(AwardItem, Forms.award);
const Publication = ProfileHOC(PublicationItem, Forms.publication);
const Summary = ProfileHOC(BodyComponents.Summary, Forms.summary, true);

const CertificateHOCList = HOCList(
	ProfileHOC(BodyComponents.CertificateItem, Forms.certificate)
);
const CertificateHOCWithList = ProfileHOCWithLists(
	Forms.certificate,
	CertificateHOCList
);

const EducationHOCList = HOCList(
	ProfileHOC(BodyComponents.EducationItem, Forms.education)
);
const EducationHOCWithList = ProfileHOCWithLists(
	Forms.education,
	EducationHOCList
);
const ExperienceHOCList = HOCList(
	ProfileHOC(BodyComponents.ExperienceItem, Forms.experience)
);
const ExperienceHOCWithList = ProfileHOCWithLists(
	Forms.experience,
	ExperienceHOCList
);

export {
	Headline,
	Location,
	Industry,
	Endorsements,
	ManageEndorsements,
	Press,
	Awards,
	Publication,
	Summary,
	ExperienceHOCWithList,
	EducationHOCWithList,
	CertificateHOCWithList,
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/HOC/HOCDecoratedComponents.js